import React from 'react';
import { Link } from 'react-router';

const SectionNoData = ({ location }) => {
let content = null;
if (location.pathname === '/Saved_events') {
  content = (
    <React.Fragment>
      You Have No Saved Events. You can add
      <Link
        className="link"
        to="/Past_Events/Surgeries"
      >
        Surgeries
      </Link>,
      <Link
        className="link"
        to="/Past_Events/Conferences"
      >
        Conferences
      </Link>,
      <Link
        className="link"
        to="/Past_Events/Webinars"
      >
        Webinars
      </Link> or
      <Link
        className="link"
        to="/Upcoming_events/"
      >
        Upcoming Events
      </Link> from the events library.
    </React.Fragment>
  )
}
if (location.pathname === '/Upcoming_events/') {
  content = 'No Upcoming Events. Please check out our on-demand video library.'
}

return content;
};

export default SectionNoData;


// WEBPACK FOOTER //
// ./src/pages/Feed/SectionNoData/index.js